// extracted by mini-css-extract-plugin
export default {"board_title":"SimplifyCard_board_title__IJLXA","board_content":"SimplifyCard_board_content__RvzvS","board_item":"SimplifyCard_board_item__5Vz7z"};